import React, { useRef, useEffect, useCallback } from 'react'

interface VideoDisplayProps {
  videoSrc: string | MediaStream;
  onVideoElementRef: (videoElement: HTMLVideoElement | null) => void;
  showVideo: boolean;
}

export const VideoDisplay: React.FC<VideoDisplayProps> = React.memo(({
  videoSrc,
  onVideoElementRef,
  showVideo,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  // Handle video element ref for replay mode
  const handleVideoRef = useCallback((video: HTMLVideoElement | null) => {
    videoRef.current = video
    onVideoElementRef(video)
  }, [onVideoElementRef])

  useEffect(() => {
    if (!videoRef.current)
      return

    if (videoSrc instanceof MediaStream) {
      // Clear src when using MediaStream
      videoRef.current.src = ''
      videoRef.current.srcObject = videoSrc
    } else if (typeof videoSrc === 'string' && videoSrc !== '') {
      // Clear srcObject when using video file
      videoRef.current.srcObject = null
      videoRef.current.src = videoSrc
    } else {
      // Clear both when no video source
      videoRef.current.srcObject = null
      videoRef.current.src = ''
      videoRef.current.pause()

      return
    }

    try {
      videoRef.current.play()
    } catch (error) {
      // Do nothing
    }
  }, [videoSrc])

  return (
    <>
      <video
        key="video-display"
        ref={handleVideoRef}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          transform: 'scaleX(-1)', // Mirror the video horizontally
          display: showVideo ? 'block' : 'none',
          pointerEvents: 'none',
        }}
        autoPlay
        loop
        muted
        playsInline
        crossOrigin="anonymous"
      />

      {!videoSrc && (
        <div style={{
          position: 'absolute',
          top: '50px',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'white',
          fontSize: '24px',
          fontWeight: 'bold',
          textAlign: 'center',
          backgroundColor: '#444',
          padding: '20px',
          borderRadius: '10px',
        }}>
            Camera stopped
        </div>
      )}
    </>
  )
})

